import { fetchAPI } from '../utils/api';
import cm from './client';
const opts = {
    headers: {
        Accept: `application/vnd.synchronoss.cm-1.0+json`,
        'Content-Type': `application/vnd.synchronoss.cm-1.0+json`,
    },
};
const apiType = 'cm';
export const fetchApi = async (params, endpoint, logger) => {
    logger ? cm.setLogger(logger) : undefined;
    return fetchAPI(endpoint.startsWith('/shared') ? endpoint : `/user/{userId}/${endpoint}`, apiType, params, opts.headers);
};
export const putCollection = async (body, endpoint, headers, logger) => {
    logger ? cm.setLogger(logger) : undefined;
    return cm.put(`/user/{userId}/${endpoint}`, apiType, {
        data: body,
        headers: { ...opts.headers, ...headers },
    });
};
export const updateCollection = async (body, endpoint, headers, logger) => {
    logger ? cm.setLogger(logger) : undefined;
    return cm.PATCH(`/user/{userId}/${endpoint}`, apiType, {
        data: body,
        headers: { ...opts.headers, ...headers },
    });
};
export const deleteCollection = async (endpoint, headers, logger) => {
    logger ? cm.setLogger(logger) : undefined;
    return cm.delete(`/user/{userId}/${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
